module.exports = __webpack_public_path__ + "static/media/Resume-20251203.c2d4296d.docx";